import * as React from "react";
import { Grid, Link } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { cgmInfoPdfSrc } from "../../utils/cgmInfoPdfSrc";

interface Props {
  dexcomInfoPage1Src: string;
  dexcomInfoPage2Src: string;
}

const CgmInfoPage: React.FC<Props> = (props: Props) => {
  const [pageNum, setPageNum] = React.useState<number>(1);

  const page1Src = cgmInfoPdfSrc(props.dexcomInfoPage1Src);
  const page2Src = cgmInfoPdfSrc(props.dexcomInfoPage2Src);

  return (
    <div className="cgm-info-container">
      <p
        className="page-title"
        style={{
          textAlign: "center",
          fontSize: 26,
          fontFamily: "$font-qs-medium",
          marginTop: 30,
        }}
      >
        Glucose Monitoring Resource
      </p>
      <Grid container justifyContent="center" className="fum-form-container">
        {pageNum == 1 ? (
          <iframe src={page1Src} width="100%" height="80%"></iframe>
        ) : (
          <iframe src={page2Src} width="100%" height="80%"></iframe>
        )}
        <Grid alignItems="center" justifyContent="center">
          <p
            className="pagerLinks"
            style={{
              textAlign: "center",
              padding: 5,
              cursor: "pointer",
              fontSize: 25,
              fontFamily: "$font-qs-medium",
            }}
          >
            <Link
              onClick={() => {
                setPageNum(1);
              }}
              className="linkDark"
            >
              <ArrowBackIosIcon style={{ width: 20, height: 20 }} />
            </Link>
            <Link
              key={1}
              onClick={() => {
                setPageNum(1);
              }}
              style={{
                color: pageNum === 1 ? "#4a4442" : "#c1b7b3",
              }}
            >
              1
            </Link>
            <Link
              key={2}
              onClick={() => {
                setPageNum(2);
              }}
              style={{
                color: pageNum === 2 ? "#4a4442" : "#c1b7b3",
              }}
            >
              2
            </Link>
            <Link
              onClick={() => {
                setPageNum(2);
              }}
              className="linkDark"
            >
              <ArrowForwardIosIcon style={{ width: 20, height: 20 }} />
            </Link>
          </p>
        </Grid>
      </Grid>
    </div>
  );
};

export default CgmInfoPage;
